document.addEventListener('DOMContentLoaded', () => {

  /* [SCROLL-ANIMATE] */
  const animatedElements = document.querySelectorAll('.animate-fade-up');
  if (animatedElements.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    animatedElements.forEach(el => observer.observe(el));
  }

  /* [CART-DRAWER] */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  const cartCloseBtns = document.querySelectorAll('[data-cart-close]');
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartOverlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  }
  cartOpenBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartCloseBtns.forEach(btn => btn.addEventListener('click', closeCart));
  cartOverlay?.addEventListener('click', closeCart);

  /**
   * Genindlæs cart drawer indhold via Shopify Section Rendering API.
   * Henter den nyeste HTML for cart-drawer sektionen og erstatter indholdet.
   */
  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var html = data['cart-drawer'];
        if (!html) return;
        /* Parse HTML og find drawer-indholdet */
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('[data-cart-drawer]');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          /* Genbind luk-knap */
          cartDrawer.querySelectorAll('[data-cart-close]').forEach(function(btn) {
            btn.addEventListener('click', closeCart);
          });
        }
        /* Opdater header badge */
        var badgeEl = document.querySelector('.cart-badge');
        var newBadge = temp.querySelector('.cart-badge');
        if (badgeEl && newBadge) {
          badgeEl.textContent = newBadge.textContent;
        }
      })
      .catch(function(err) {
        console.warn('Cart drawer refresh fejlede:', err);
      });
  }

  /**
   * Event delegation for cart drawer knapper.
   * Bindes ÉN gang på drawer-elementet og virker altid,
   * selv efter innerHTML er udskiftet via refreshCartDrawer().
   */
  /* Hjælper: Find 1-baseret linje-index for en cart-item */
  function getCartLineIndex(cartItemEl) {
    var allItems = cartDrawer.querySelectorAll('.cart-item');
    for (var i = 0; i < allItems.length; i++) {
      if (allItems[i] === cartItemEl) return i + 1;
    }
    return -1;
  }

  /* Hjælper: Send ændring til Shopify Cart API og refresh drawer */
  function cartChange(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function() { refreshCartDrawer(); })
    .catch(function(err) { console.warn('Cart change fejlede:', err); });
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function(e) {
      /* Brug closest() så klik på tekst/child-elementer også fanges */
      var removeBtn = e.target.closest('.cart-item__remove');
      var minusBtn = e.target.closest('[aria-label="Fjern 1"]');
      var plusBtn = e.target.closest('[aria-label="Tilføj 1"]');

      /* ── Fjern-knap ── */
      if (removeBtn) {
        e.preventDefault();
        var cartItem = removeBtn.closest('.cart-item');
        if (!cartItem) return;
        var line = getCartLineIndex(cartItem);
        if (line < 1) return;
        cartChange(line, 0);
        return;
      }

      /* ── Kvantitet minus ── */
      if (minusBtn) {
        e.preventDefault();
        var cartItem = minusBtn.closest('.cart-item');
        if (!cartItem) return;
        var line = getCartLineIndex(cartItem);
        if (line < 1) return;
        var qtyEl = cartItem.querySelector('.quantity-selector__value');
        var currentQty = qtyEl ? parseInt(qtyEl.textContent) || 1 : 1;
        cartChange(line, Math.max(0, currentQty - 1));
        return;
      }

      /* ── Kvantitet plus ── */
      if (plusBtn) {
        e.preventDefault();
        var cartItem = plusBtn.closest('.cart-item');
        if (!cartItem) return;
        var line = getCartLineIndex(cartItem);
        if (line < 1) return;
        var qtyEl = cartItem.querySelector('.quantity-selector__value');
        var currentQty = qtyEl ? parseInt(qtyEl.textContent) || 1 : 1;
        cartChange(line, currentQty + 1);
        return;
      }
    });
  }

  /* [ADD-TO-CART] — v11: FormData med line item properties (tangent-valg inkluderet) */
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      /* Strip empty line item properties before submit */
      document.querySelectorAll('[data-cfg-prop]').forEach(input => {
        if (!input.value) input.disabled = true;
      });
      const iconColorInput = document.querySelector('[data-cfg-prop-icon-color]');
      const hasAnyIcon = cfgState.keys.some(k => k);
      if (iconColorInput && !hasAnyIcon) iconColorInput.disabled = true;

      /* Tangent properties sendes altid med (uanset om det er Standard) */

      /* Submit form via fetch for AJAX add-to-cart */
      const form = document.querySelector('[data-product-form]');
      if (form) {
        const formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function(res) {
            if (!res.ok) throw new Error('Shopify svarede ' + res.status);
            return res.json();
          })
          .then(function() {
            /* Re-enable inputs */
            document.querySelectorAll('[data-cfg-prop]').forEach(function(i) { i.disabled = false; });
            if (iconColorInput) iconColorInput.disabled = false;
            document.querySelectorAll('[data-lk-prop]').forEach(function(i) { i.disabled = false; });

            var originalText = btn.textContent;
            btn.classList.add('is-added');
            btn.textContent = '✓ Tilføjet til kurv';
            var badge = document.querySelector('.cart-badge');
            if (badge) {
              badge.classList.add('is-bouncing');
              setTimeout(function() { badge.classList.remove('is-bouncing'); }, 400);
            }

            /* Refresh cart drawer og åbn den */
            refreshCartDrawer().then(function() {
              setTimeout(function() { openCart(); }, 300);
            });

            setTimeout(function() {
              btn.classList.remove('is-added');
              btn.textContent = originalText;
            }, 2000);
          })
          .catch(function(err) {
            console.warn('Add-to-cart fejlede:', err);
            document.querySelectorAll('[data-cfg-prop]').forEach(function(i) { i.disabled = false; });
            if (iconColorInput) iconColorInput.disabled = false;
            document.querySelectorAll('[data-lk-prop]').forEach(function(i) { i.disabled = false; });
            btn.textContent = 'Prøv igen';
            btn.style.background = '#ef4444';
            btn.style.color = '#fff';
            setTimeout(function() {
              btn.textContent = 'Læg i kurv — fri fragt ✓';
              btn.style.background = '';
              btn.style.color = '';
            }, 3000);
          });
      }
    });
  });

  /* [STICKY-CTA] */
  const primaryCTA = document.querySelector('[data-primary-cta]');
  const stickyCTA = document.querySelector('[data-sticky-cta]');
  if (primaryCTA && stickyCTA) {
    const ctaObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyCTA.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    ctaObserver.observe(primaryCTA);
  }

  /* [EXIT-POPUP] */
  const popup = document.querySelector('[data-popup]');
  const popupOverlay = document.querySelector('[data-popup-overlay]');
  const popupClose = document.querySelectorAll('[data-popup-close]');
  let popupShown = false;
  let savedScrollY = 0;
  function showPopup() {
    if (popupShown || !popupOverlay) return;
    popupShown = true;
    savedScrollY = window.scrollY;
    popupOverlay.classList.add('is-visible');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }
  function hidePopup() {
    if (!popupOverlay) return;
    popupOverlay.classList.remove('is-visible');
    /* Disable smooth scroll so restore is instant */
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, savedScrollY);
    /* Re-enable smooth scroll on next frame */
    requestAnimationFrame(() => {
      document.documentElement.style.scrollBehavior = '';
    });
  }
  if (window.innerWidth >= 768) {
    document.addEventListener('mouseout', (e) => {
      if (e.clientY <= 0 && !popupShown) {
        if (performance.now() > 5000) showPopup();
      }
    });
  }
  popupClose.forEach(btn => btn.addEventListener('click', hidePopup));
  popupOverlay?.addEventListener('click', (e) => {
    if (e.target === popupOverlay) hidePopup();
  });

  /* [SHIPPING-BAR] */
  function updateShippingBar(cartTotal, threshold) {
    const bar = document.querySelector('[data-shipping-fill]');
    const text = document.querySelector('[data-shipping-text]');
    if (!bar || !text) return;
    const remaining = threshold - cartTotal;
    const percent = Math.min((cartTotal / threshold) * 100, 100);
    bar.style.width = percent + '%';
    if (remaining <= 0) {
      bar.classList.add('is-complete');
      text.textContent = '✓ Du har gratis fragt!';
    } else {
      bar.classList.remove('is-complete');
      text.innerHTML = `🚚 Du mangler <strong>${remaining} kr.</strong> for gratis fragt`;
    }
  }

  /* [MDI-ICONS] */
  const MDI_ICONS = {
    popular: [
      { name: 'lightbulb', label: 'Pære', path: 'M12 2a7 7 0 0 0-4 12.73V16a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1.27A7 7 0 0 0 12 2zm-1 17h2v1a1 1 0 0 1-2 0v-1z' },
      { name: 'brightness-6', label: 'Lysstyrke', path: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18V6a6 6 0 0 1 0 12z' },
      { name: 'ceiling-light', label: 'Loftlampe', path: 'M8 9h8l2 4H6l2-4zm3-7h2v4h-2V2zM8 15h8v2H8v-2zm2 3h4v2h-4v-2z' },
      { name: 'lamp', label: 'Lampe', path: 'M8 4h8l2 8H6l2-8zm-1 10h10v1H7v-1zm3 2h4v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4z' },
      { name: 'fan', label: 'Ventilator', path: 'M12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-1-8.95A6.97 6.97 0 0 0 7.05 5L5 3l-2 2 2 2.05A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 .05 4.95L3 19l2 2 2.05-2A6.97 6.97 0 0 0 12 19a6.97 6.97 0 0 0 4.95-.05L19 21l2-2-2-2.05A6.97 6.97 0 0 0 19 12c0-1.74-.63-3.33-1.69-4.55L19 5l-2-2-1.45 1.45A6.97 6.97 0 0 0 11 2.05z' },
      { name: 'thermostat', label: 'Termostat', path: 'M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-8c0-.55.45-1 1-1s1 .45 1 1h-1v1h1v2h-1v1h1v2h-2V5z' },
      { name: 'power', label: 'Strøm', path: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0 1 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.05.89-3.89 2.3-5.17L5.88 5.46A8.96 8.96 0 0 0 3 12a9 9 0 1 0 14.83-6.83z' },
      { name: 'home', label: 'Hjem', path: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' },
      { name: 'lock', label: 'Lås', path: 'M18 10h-1V7A5 5 0 0 0 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-6 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM9 10V7a3 3 0 0 1 6 0v3H9z' },
      { name: 'television', label: 'Fjernsyn', path: 'M21 3H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 14H3V5h18v12z' },
      { name: 'volume-high', label: 'Lydstyrke', path: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' },
      { name: 'speaker', label: 'Højttaler', path: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02z' },
    ],
    light: [
      { name: 'lightbulb', label: 'Pære', path: 'M12 2a7 7 0 0 0-4 12.73V16a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1.27A7 7 0 0 0 12 2zm-1 17h2v1a1 1 0 0 1-2 0v-1z' },
      { name: 'brightness-6', label: 'Lysstyrke', path: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18V6a6 6 0 0 1 0 12z' },
      { name: 'ceiling-light', label: 'Loftlampe', path: 'M8 9h8l2 4H6l2-4zm3-7h2v4h-2V2zM8 15h8v2H8v-2zm2 3h4v2h-4v-2z' },
      { name: 'lamp', label: 'Lampe', path: 'M8 4h8l2 8H6l2-8zm-1 10h10v1H7v-1zm3 2h4v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4z' },
      { name: 'led-strip', label: 'LED-strip', path: 'M2 11h3v2H2v-2zm5 0h3v2H7v-2zm5 0h3v2h-3v-2zm5 0h3v2h-3v-2zm-15 4h20v2H2v-2z' },
      { name: 'lightbulb-off', label: 'Slukket', path: 'M12 2a7 7 0 0 0-4 12.73V16a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1.27A7 7 0 0 0 12 2zM3.27 3L2 4.27l5.34 5.34A7 7 0 0 0 8 14.73V16a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1.27c.3-.21.58-.44.83-.7L19.73 21 21 19.73 3.27 3z' },
      { name: 'floor-lamp', label: 'Gulvlampe', path: 'M8 3h8l1 6H7l1-6zM11 11h2v8h2l-3 3-3-3h2v-8z' },
      { name: 'desk-lamp', label: 'Skrivebordslampe', path: 'M14 2l-4 8h3v6H9v2h10v-2h-4v-6h3L14 2zm-6 18h8v2H8v-2z' },
      { name: 'light-switch', label: 'Kontakt', path: 'M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm5 4a3 3 0 0 0-3 3v2a3 3 0 0 0 6 0V9a3 3 0 0 0-3-3z' },
      { name: 'moon-waning-crescent', label: 'Måne', path: 'M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36a5.39 5.39 0 0 1-4.4 2.26 5.4 5.4 0 0 1-3.14-9.8c-.44-.06-.9-.1-1.36-.1z' },
    ],
    climate: [
      { name: 'thermostat', label: 'Termostat', path: 'M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-8c0-.55.45-1 1-1s1 .45 1 1h-1v1h1v2h-1v1h1v2h-2V5z' },
      { name: 'fan', label: 'Ventilator', path: 'M12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-1-8.95A6.97 6.97 0 0 0 7.05 5L5 3l-2 2 2 2.05A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 .05 4.95L3 19l2 2 2.05-2A6.97 6.97 0 0 0 12 19a6.97 6.97 0 0 0 4.95-.05L19 21l2-2-2-2.05A6.97 6.97 0 0 0 19 12c0-1.74-.63-3.33-1.69-4.55L19 5l-2-2-1.45 1.45A6.97 6.97 0 0 0 11 2.05z' },
      { name: 'snowflake', label: 'Snefnug', path: 'M20.79 13.95L18 12l2.79-1.95-1.16-1.65L16.5 10.5 13 8.29V5h2V3h-2V1h-2v2H9v2h2v3.29L7.5 10.5 4.37 8.4l-1.16 1.65L6 12l-2.79 1.95 1.16 1.65L7.5 13.5 11 15.71V19H9v2h2v2h2v-2h2v-2h-2v-3.29l3.5-2.21 3.13 2.1 1.16-1.65z' },
      { name: 'fire', label: 'Ild', path: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67z' },
      { name: 'water-percent', label: 'Fugtighed', path: 'M12 3.77L7.06 10.5A5.94 5.94 0 0 0 6 14a6 6 0 0 0 12 0c0-1.28-.37-2.47-1.06-3.5L12 3.77z' },
      { name: 'air-conditioner', label: 'Klimaanlæg', path: 'M6 3h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 2v6h12V5H6zm1 10c0 1.1.45 2.1 1.17 2.83l1.42-1.42A2 2 0 0 1 9 15H7zm10 0h-2a2 2 0 0 1-.59 1.41l1.42 1.42A4 4 0 0 0 17 15zm-5 0a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4h-2z' },
      { name: 'radiator', label: 'Radiator', path: 'M6 4v16h2V4H6zm4 0v16h2V4h-2zm4 0v16h2V4h-2zm4 0v16h2V4h-2zM4 4H3v16h1V4zm17 0h-1v16h1V4z' },
    ],
    power: [
      { name: 'power', label: 'Strøm', path: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0 1 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.05.89-3.89 2.3-5.17L5.88 5.46A8.96 8.96 0 0 0 3 12a9 9 0 1 0 14.83-6.83z' },
      { name: 'power-plug', label: 'Stik', path: 'M16 7V3h-2v4h-4V3H8v4H6v5a6 6 0 0 0 5 5.91V21h2v-3.09A6 6 0 0 0 18 12V7h-2z' },
      { name: 'toggle-switch', label: 'Toggle', path: 'M7 7a5 5 0 0 0 0 10h10a5 5 0 0 0 0-10H7zm10 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6z' },
      { name: 'flash', label: 'Lyn', path: 'M7 2v11h3v9l7-12h-4l4-8z' },
      { name: 'battery', label: 'Batteri', path: 'M17 4h-3V2h-4v2H7a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 17H7V6h10v15z' },
    ],
    media: [
      { name: 'play-pause', label: 'Afspil', path: 'M8 5v14l11-7L8 5z' },
      { name: 'volume-high', label: 'Lydstyrke', path: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' },
      { name: 'television', label: 'Fjernsyn', path: 'M21 3H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 14H3V5h18v12z' },
      { name: 'speaker', label: 'Højttaler', path: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02z' },
      { name: 'music', label: 'Musik', path: 'M12 3v10.55A4 4 0 1 0 14 17V7h4V3h-6z' },
      { name: 'microphone', label: 'Mikrofon', path: 'M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.93V21h2v-3.07A7 7 0 0 0 19 11h-2z' },
      { name: 'headphones', label: 'Høretelefoner', path: 'M12 1a9 9 0 0 0-9 9v7c0 1.66 1.34 3 3 3h2v-8H5v-2a7 7 0 0 1 14 0v2h-3v8h2c1.66 0 3-1.34 3-3v-7a9 9 0 0 0-9-9z' },
    ],
    home: [
      { name: 'home', label: 'Hjem', path: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' },
      { name: 'door', label: 'Dør', path: 'M6 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm10 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z' },
      { name: 'window-open', label: 'Vindue', path: 'M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v6h6V5H5zm8 0v6h6V5h-6zm-8 8v6h6v-6H5zm8 0v6h6v-6h-6z' },
      { name: 'blinds-horizontal', label: 'Gardiner', path: 'M3 3h18v2H3V3zm0 4h18v2H3V7zm0 4h18v2H3v-2zm0 4h18v2H3v-2zm0 4h18v2H3v-2z' },
      { name: 'couch', label: 'Sofa', path: 'M21 9V7a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2a3 3 0 0 0-2 2.83V16h2v2h2v-2h14v2h2v-2h2v-4.17A3 3 0 0 0 21 9z' },
      { name: 'bed', label: 'Seng', path: 'M7 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm13-5h-8v5h10V11a2 2 0 0 0-2-2zM2 17h20v2H2v-2z' },
      { name: 'monitor', label: 'Skærm', path: 'M21 2H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7v2H8v2h8v-2h-2v-2h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 14H4V4h16v12z' },
    ],
    security: [
      { name: 'lock', label: 'Lås', path: 'M18 10h-1V7A5 5 0 0 0 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-6 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM9 10V7a3 3 0 0 1 6 0v3H9z' },
      { name: 'shield', label: 'Skjold', path: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z' },
      { name: 'alarm', label: 'Alarm', path: 'M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' },
      { name: 'camera', label: 'Kamera', path: 'M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4zM9 2l-1.83 2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3.17L15 2H9zm3 15a5 5 0 1 1 0-10 5 5 0 0 1 0 10z' },
      { name: 'eye', label: 'Øje', path: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z' },
      { name: 'key', label: 'Nøgle', path: 'M12.65 10A3.5 3.5 0 0 0 6 8.5 3.5 3.5 0 0 0 12.65 10h1.85l1 1 1-1 1 1 1.5-1.5-1.5-1.5H12.65zM8.5 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2z' },
    ],
  };

  MDI_ICONS.all = [...new Map(Object.values(MDI_ICONS).flat().map(i => [i.name, i])).values()];

  /* ══════════════════════════════════════════
     [VARIANT SYSTEM v7] — Shopify Native
     ══════════════════════════════════════════ */

  let productData = null;
  let selectedOptions = [];

  /*
   * Ikon-positioner som CSS-procenter (målt fra 398×400 reference-billeder).
   * Fordi vi bruger %-baseret CSS-positionering, skalerer de automatisk
   * med billedet — ingen viewBox, ingen JS-beregning, ingen race conditions.
   */

  function initVariantSystem() {
    const jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return;

    try { productData = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    /* Initialise selectedOptions from current variant */
    selectedOptions = productData.options.map((_, i) => {
      const firstVariant = productData.variants[0];
      return firstVariant ? firstVariant.options[i] : '';
    });

    /* Re-read from selected buttons (may differ from first variant) */
    document.querySelectorAll('[data-variant-value].is-selected').forEach(btn => {
      const idx = parseInt(btn.dataset.optionIndex);
      if (!isNaN(idx)) selectedOptions[idx] = btn.dataset.variantValue;
    });

    /* Attach click listeners to all variant buttons */
    document.querySelectorAll('[data-variant-value]').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.optionIndex);
        const value = btn.dataset.variantValue;
        selectedOptions[idx] = value;

        /* Update button states within same option group */
        const parent = btn.closest('.cfg__swatch-row');
        if (parent) {
          parent.querySelectorAll('[data-variant-value]').forEach(b => {
            b.classList.toggle('is-selected', b === btn);
          });
        }

        /* Update option label */
        const optionName = btn.closest('[data-variant-option]')?.dataset.variantOption;
        if (optionName) {
          const label = document.querySelector(`[data-option-label="${optionName}"]`);
          if (label) label.textContent = value;
        }

        updateVariant();
      });
    });

    /* Set initial variant */
    updateVariant();
  }

  function findMatchingVariant() {
    if (!productData) return null;
    return productData.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
  }

  function updateVariant() {
    const variant = findMatchingVariant();
    if (!variant) return;

    /* Update hidden variant ID */
    const idInput = document.querySelector('[data-variant-id]');
    if (idInput) idInput.value = variant.id;

    /* Update price display */
    const priceEl = document.querySelector('[data-variant-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    const stickyPrice = document.querySelector('[data-variant-price-sticky]');
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    /* Update compare-at price */
    const compareEl = document.querySelector('[data-variant-compare-price]');
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    /* Update product image */
    const img = document.querySelector('[data-variant-img]');
    if (img && variant.featured_image) {
      img.src = variant.featured_image;
    }

    /* Update availability */
    const addBtn = document.querySelector('[data-add-to-cart]');
    const availWrap = document.querySelector('[data-variant-availability]');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Læg i kurv — fri fragt ✓' : 'Udsolgt';
    }
    if (availWrap) {
      availWrap.innerHTML = variant.available
        ? '<div style="display:flex;align-items:center;gap:8px;font-size:var(--font-size-base)"><span style="color:var(--color-success);font-size:18px">✓</span><span><strong style="color:var(--color-success)">På lager</strong> — Levering 1–3 hverdage</span></div>'
        : '<div style="color:var(--color-danger);font-size:var(--font-size-base)">Midlertidigt udsolgt</div>';
    }

    /* Update URL without page reload */
    if (history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
    }

    /* Reposition icon overlay for new frame type */
    repositionAllIcons();
  }

  function formatMoney(cents) {
    /* Shopify prices are in smallest currency unit (øre) */
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' kr.';
  }


  /* ══════════════════════════════════════════
     [ICON CONFIGURATOR v8] — CSS %-positionering
     + Line Item Properties
     ══════════════════════════════════════════ */

  /* Icon positions as CSS percentages per frame type — pulled toward horizontal center */
  const ICON_POSITIONS = {
    'Bred':       [{ top: 35.5, left: 34.61 }, { top: 35.5, left: 65.64 }, { top: 64.5, left: 34.61 }, { top: 64.5, left: 65.64 }],
    'Smal':       [{ top: 31.0, left: 30.03 }, { top: 31.0, left: 69.97 }, { top: 69.0, left: 30.03 }, { top: 69.0, left: 69.97 }],
    'Uden ramme': [{ top: 29.5, left: 31.16 }, { top: 29.5, left: 68.34 }, { top: 69.5, left: 31.16 }, { top: 69.5, left: 68.34 }],
  };
  const DEFAULT_POSITIONS = ICON_POSITIONS['Bred'];

  const cfgState = {
    iconColor: 'black',
    keys: [null, null, null, null],
    activeKey: 1,
  };

  function setActiveKey(keyNum) {
    cfgState.activeKey = keyNum;
    document.querySelectorAll('[data-cfg-key-tab]').forEach(tab => {
      tab.classList.toggle('is-active', parseInt(tab.dataset.cfgKeyTab) === keyNum);
    });
    moveRing(keyNum);
    const activeLabel = document.querySelector('[data-cfg-active-label]');
    if (activeLabel) {
      const slotNames = {
        1: 'øverst venstre',
        2: 'øverst højre',
        3: 'nederst venstre',
        4: 'nederst højre',
      };
      activeLabel.innerHTML = `Vælg ikon til <strong>${slotNames[keyNum]}</strong>`;
    }
  }

  function getCurrentPositions() {
    /* Determine frame type from selected variant options */
    const frameOption = selectedOptions.find(o => {
      const lc = (o || '').toLowerCase();
      return lc.includes('bred') || lc.includes('smal') || lc.includes('uden');
    });
    if (frameOption) {
      for (const key of Object.keys(ICON_POSITIONS)) {
        if (frameOption.toLowerCase().includes(key.toLowerCase())) {
          return ICON_POSITIONS[key];
        }
      }
    }
    return DEFAULT_POSITIONS;
  }

  function moveRing(keyNum) {
    const ring = document.querySelector('[data-cfg-ring]');
    if (!ring) return;
    const positions = getCurrentPositions();
    const pos = positions[keyNum - 1] || positions[0];
    ring.style.top = pos.top + '%';
    ring.style.left = pos.left + '%';
    ring.style.opacity = '1';
  }

  function repositionAllIcons() {
    const positions = getCurrentPositions();
    for (let i = 0; i < 4; i++) {
      const slot = document.querySelector(`[data-cfg-icon-slot="${i + 1}"]`);
      if (slot && positions[i]) {
        slot.style.top = positions[i].top + '%';
        slot.style.left = positions[i].left + '%';
      }
    }
    moveRing(cfgState.activeKey);
    /* Also reposition LK tangent overlay slots */
    repositionLkSlots();
  }

  function repositionLkSlots() {
    const positions = getCurrentPositions();
    for (let i = 0; i < 4; i++) {
      const slot = document.querySelector(`[data-lk-icon-slot="${i + 1}"]`);
      if (slot && positions[i]) {
        slot.style.top = positions[i].top + '%';
        slot.style.left = positions[i].left + '%';
      }
    }
    updateLkIconColor();
  }

  function updateLkIconColor() {
    const overlay = document.querySelector('[data-lk-overlay]');
    if (!overlay) return;
    /* Tjek om den valgte farve-variant er mørk (koks/dark) */
    const colorOption = selectedOptions.find(o => {
      const lc = (o || '').toLowerCase();
      return lc.includes('hvid') || lc.includes('koks') || lc.includes('dark') || lc.includes('white');
    });
    const isDark = colorOption && (colorOption.toLowerCase().includes('koks') || colorOption.toLowerCase().includes('dark'));
    overlay.style.color = isDark ? '#FFFFFF' : '#1A1A1A';
  }

  function renderIconInSlot(keyNum, icon) {
    const slot = document.querySelector(`[data-cfg-icon-slot="${keyNum}"]`);
    if (!slot) return;
    if (!icon) {
      slot.innerHTML = '';
      return;
    }
    const fillMap = { black: '#1A1A1A', white: '#FFFFFF' };
    const fill = fillMap[cfgState.iconColor] || '#1A1A1A';
    slot.innerHTML = `<svg viewBox="0 0 24 24" width="36" height="36"><path d="${icon.path}" fill="${fill}"/></svg>`;
  }

  function selectIconForKey(keyNum, iconName) {
    const icon = MDI_ICONS.all.find(i => i.name === iconName);
    if (!icon) return;
    cfgState.keys[keyNum - 1] = icon;
    renderIconInSlot(keyNum, icon);

    /* Update line item property */
    const prop = document.querySelector(`[data-cfg-prop="${keyNum}"]`);
    if (prop) prop.value = icon.label;

    /* Update tab preview */
    const tab = document.querySelector(`[data-cfg-key-tab="${keyNum}"]`);
    if (tab) tab.classList.add('has-icon');

    updateIconCount();

    /* Auto-advance to next empty slot */
    const nextKey = keyNum < 4 ? keyNum + 1 : null;
    if (nextKey && !cfgState.keys[nextKey - 1]) {
      setActiveKey(nextKey);
    }
  }

  function clearIconForKey(keyNum) {
    cfgState.keys[keyNum - 1] = null;
    renderIconInSlot(keyNum, null);
    const prop = document.querySelector(`[data-cfg-prop="${keyNum}"]`);
    if (prop) prop.value = '';
    const tab = document.querySelector(`[data-cfg-key-tab="${keyNum}"]`);
    if (tab) tab.classList.remove('has-icon');
    updateIconCount();
  }

  function updateIconCount() {
    const count = cfgState.keys.filter(k => k).length;
    const el = document.querySelector('[data-cfg-icon-count]');
    if (el) {
      el.textContent = count > 0 ? `${count} ikon${count > 1 ? 'er' : ''} valgt` : 'Valgfrit tilkøb';
    }
  }

  function selectIconColor(color) {
    cfgState.iconColor = color;
    document.querySelectorAll('[data-cfg-icon-color]').forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.cfgIconColor === color);
    });

    /* Update line item property */
    const colorProp = document.querySelector('[data-cfg-prop-icon-color]');
    if (colorProp) colorProp.value = color === 'white' ? 'Hvid' : 'Sort';

    /* Re-render all placed icons with new color */
    cfgState.keys.forEach((icon, i) => {
      if (icon) renderIconInSlot(i + 1, icon);
    });

    checkContrastWarning();
  }

  function checkContrastWarning() {
    const warn = document.querySelector('[data-cfg-contrast-warn]');
    if (!warn) return;
    /* Check current variant color to determine key color */
    const colorOption = selectedOptions.find(o => {
      const lc = (o || '').toLowerCase();
      return lc.includes('hvid') || lc.includes('koks') || lc.includes('dark') || lc.includes('white');
    });
    const isLightKeys = !colorOption || colorOption.toLowerCase().includes('hvid') || colorOption.toLowerCase().includes('white');
    const isLowContrast = (isLightKeys && cfgState.iconColor === 'white') ||
                           (!isLightKeys && cfgState.iconColor === 'black');
    warn.classList.toggle('is-visible', isLowContrast);
  }

  function applyPreset(names) {
    names.forEach((name, idx) => {
      const icon = MDI_ICONS.all.find(i => i.name === name.trim());
      if (icon && idx < 4) {
        cfgState.keys[idx] = icon;
        renderIconInSlot(idx + 1, icon);
        const prop = document.querySelector(`[data-cfg-prop="${idx + 1}"]`);
        if (prop) prop.value = icon.label;
        const tab = document.querySelector(`[data-cfg-key-tab="${idx + 1}"]`);
        if (tab) tab.classList.add('has-icon');
      }
    });
    updateIconCount();
  }

  function renderIconGrid(category) {
    const icons = MDI_ICONS[category] || MDI_ICONS.popular;
    renderIconGridItems(icons);
  }

  function renderIconGridItems(icons) {
    const grid = document.querySelector('[data-cfg-icon-grid]');
    if (!grid) return;
    grid.innerHTML = '';
    icons.forEach(icon => {
      const btn = document.createElement('button');
      btn.className = 'cfg__icon-btn';
      btn.type = 'button';
      btn.innerHTML = `<svg viewBox="0 0 24 24" width="24" height="24"><path d="${icon.path}" fill="currentColor"/></svg><span class="cfg__icon-label">${icon.label}</span>`;
      btn.title = icon.label;
      btn.addEventListener('click', () => selectIconForKey(cfgState.activeKey, icon.name));
      grid.appendChild(btn);
    });
  }

  /* ── Init Icon Configurator ── */
  function initConfigurator() {
    const cfg = document.querySelector('[data-configurator]');
    if (!cfg) return;

    /* Key tabs */
    cfg.querySelectorAll('[data-cfg-key-tab]').forEach(tab => {
      tab.addEventListener('click', () => setActiveKey(parseInt(tab.dataset.cfgKeyTab)));
    });

    /* Icon color */
    cfg.querySelectorAll('[data-cfg-icon-color]').forEach(btn => {
      btn.addEventListener('click', () => selectIconColor(btn.dataset.cfgIconColor));
    });

    /* Presets */
    cfg.querySelectorAll('[data-cfg-preset]').forEach(btn => {
      btn.addEventListener('click', () => {
        const names = btn.dataset.cfgPreset.split(',');
        applyPreset(names);
      });
    });

    /* Categories */
    cfg.querySelectorAll('[data-cfg-cat]').forEach(btn => {
      btn.addEventListener('click', () => {
        cfg.querySelectorAll('[data-cfg-cat]').forEach(b => b.classList.toggle('is-active', b === btn));
        renderIconGrid(btn.dataset.cfgCat);
      });
    });

    /* Search */
    const searchInput = cfg.querySelector('[data-cfg-search]');
    if (searchInput) {
      let timer;
      searchInput.addEventListener('input', (e) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          const q = e.target.value.trim().toLowerCase();
          if (q.length > 0) {
            const filtered = MDI_ICONS.all.filter(i => i.label.toLowerCase().includes(q) || i.name.includes(q));
            renderIconGridItems(filtered);
          } else {
            renderIconGrid('popular');
          }
        }, 200);
      });
    }

    /* Clear icon button */
    const clearBtn = cfg.querySelector('[data-cfg-clear-icon]');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => clearIconForKey(cfgState.activeKey));
    }

    /* Init defaults */
    renderIconGrid('popular');
    setActiveKey(1);
  }


  /* [SCROLL-SHOWCASE] */
  function initScrollShowcase() {
    const dataEl = document.querySelector('[data-scroll-scenarios]');
    if (!dataEl) return;

    let scenarios;
    try { scenarios = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const section = document.querySelector('[data-scroll-showcase]');
    if (!section) return;

    const bg = section.querySelector('[data-scroll-bg]');
    const headline = section.querySelector('[data-scroll-headline]');
    const subline = section.querySelector('[data-scroll-subline]');
    const dots = section.querySelectorAll('[data-scroll-dot]');
    const cta = section.querySelector('[data-scroll-cta]');
    const iconFillMap = { black: '#1A1A1A', white: '#FFFFFF' };
    let currentScene = -1;

    function renderScene(idx) {
      if (idx === currentScene || !scenarios[idx]) return;
      currentScene = idx;
      const s = scenarios[idx];

      if (headline) {
        headline.textContent = s.headline;
        const isDark = isColorDark(s.bg);
        headline.classList.toggle('is-dark', isDark);
        if (subline) {
          subline.textContent = s.subline;
          subline.classList.toggle('is-dark', isDark);
        }
      }

      if (bg) bg.style.background = s.bg;

      const scrollImg = section.querySelector('[data-scroll-img]');
      if (scrollImg) {
        const srcAttr = s.keyColor === 'dark' ? 'data-src-dark' : 'data-src-white';
        scrollImg.src = scrollImg.getAttribute(srcAttr) || scrollImg.getAttribute('data-src-white');
      }

      const iconFill = iconFillMap[s.iconColor] || '#1A1A1A';
      s.icons.forEach((iconName, i) => {
        const slot = section.querySelector(`[data-sicon="${i + 1}"]`);
        if (!slot) return;
        const icon = MDI_ICONS.all.find(ic => ic.name === iconName);
        if (icon) {
          slot.innerHTML = `<path d="${icon.path}" fill="${iconFill}" transform="scale(1.5) translate(-12,-12)"/>`;
        }
      });

      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));

      if (cta) {
        cta.classList.toggle('is-visible', idx === scenarios.length - 1);
      }
    }

    function isColorDark(hex) {
      if (!hex || hex.charAt(0) !== '#') return false;
      const c = hex.replace('#', '');
      const r = parseInt(c.substr(0, 2), 16);
      const g = parseInt(c.substr(2, 2), 16);
      const b = parseInt(c.substr(4, 2), 16);
      return (r * 299 + g * 587 + b * 114) / 1000 < 128;
    }

    renderScene(0);

    function onScroll() {
      const rect = section.getBoundingClientRect();
      const sectionH = section.offsetHeight;
      const viewH = window.innerHeight;
      const scrolled = -rect.top;
      const scrollRange = sectionH - viewH;
      if (scrollRange <= 0) return;
      const progress = Math.max(0, Math.min(1, scrolled / scrollRange));
      const sceneIdx = Math.min(Math.floor(progress * scenarios.length), scenarios.length - 1);
      renderScene(sceneIdx);
    }

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => { onScroll(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ══════════════════════════════════════════
     [LK-TANGENT-SELECTOR v10] — Separate produkter
     Tangent-valg tilføjer separate produkter til kurven.
     ══════════════════════════════════════════ */

  /* SVG-ikoner til LK tangent overlay */
  const LK_TANGENT_ICONS = {
    'icon-op': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="36" height="36" fill="none" stroke="currentColor"><path d="M20 75 L50 20 L80 75" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/><line x1="50" y1="80" x2="50" y2="60" stroke-width="6" stroke-linecap="round"/></svg>',
    'icon-ned': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="36" height="36" fill="none" stroke="currentColor"><path d="M20 25 L50 80 L80 25" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="50" cy="35" r="9" stroke-width="6" fill="none"/></svg>',
    'icon-i': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="36" height="36" fill="none" stroke="currentColor"><line x1="50" y1="20" x2="50" y2="80" stroke-width="10" stroke-linecap="round"/></svg>',
    'icon-o': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="36" height="36" fill="none" stroke="currentColor"><circle cx="50" cy="50" r="25" stroke-width="10" fill="none"/></svg>',
  };

  /*
   * Mapping: tangent-valg → hvilke ikoner der placeres i slots.
   * Øverste tangent bruger slot 1+2, nederste tangent bruger slot 3+4.
   */
  const LK_TANGENT_SLOT_MAP = {
    top: {
      'pile': { 1: 'icon-op', 2: 'icon-ned' },
      'io': { 1: 'icon-i', 2: 'icon-o' },
    },
    bottom: {
      'pile': { 3: 'icon-op', 4: 'icon-ned' },
      'io': { 3: 'icon-i', 4: 'icon-o' },
    },
  };

  function renderLkSlotIcon(slotNum, iconKey) {
    const slot = document.querySelector(`[data-lk-icon-slot="${slotNum}"]`);
    if (!slot) return;
    if (!iconKey || !LK_TANGENT_ICONS[iconKey]) {
      slot.innerHTML = '';
      return;
    }
    slot.innerHTML = LK_TANGENT_ICONS[iconKey];
  }

  function updateLkTangentSlots(position, value) {
    const slotOffset = position === 'top' ? 0 : 2;
    const mapping = LK_TANGENT_SLOT_MAP[position]?.[value];
    /* Ryd slots for denne tangent-halvdel */
    renderLkSlotIcon(slotOffset + 1, null);
    renderLkSlotIcon(slotOffset + 2, null);
    /* Sæt ikoner hvis mapping findes */
    if (mapping) {
      if (mapping[slotOffset + 1]) renderLkSlotIcon(slotOffset + 1, mapping[slotOffset + 1]);
      if (mapping[slotOffset + 2]) renderLkSlotIcon(slotOffset + 2, mapping[slotOffset + 2]);
    }
  }

  function initLkTangentSelector() {
    const labelMap = { 'standard': 'Standard', 'pile': 'Pile', 'io': 'I/O' };

    document.querySelectorAll('[data-lk-tangent]').forEach(btn => {
      btn.addEventListener('click', () => {
        const position = btn.dataset.lkPosition;
        const value = btn.dataset.lkTangent;
        const group = btn.closest('[data-lk-tangent-group]');
        if (group) {
          group.querySelectorAll('.lk-tangent-btn').forEach(b => b.classList.remove('is-selected'));
        }
        btn.classList.add('is-selected');

        /* Opdater hidden input med tangent-label */
        const prop = document.querySelector(`[data-lk-prop="${position}"]`);
        if (prop) prop.value = labelMap[value] || value;

        /* Opdater ikon-overlay for denne tangent-halvdel */
        updateLkTangentSlots(position, value);
      });
    });
  }

  /* [ACCORDION] */
  function initAccordions() {
    document.querySelectorAll('.content-accordion__header').forEach(header => {
      header.addEventListener('click', () => {
        const item = header.closest('.content-accordion__item');
        if (item) {
          item.classList.toggle('is-open');
        }
      });
    });
  }

  /* [MOBILE-SEARCH] */
  function initMobileSearch() {
    var searchBar = document.querySelector('[data-mobile-search-bar]');
    if (!searchBar) return;

    function openSearch() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      searchBar.classList.add('is-open');
      setTimeout(function() {
        var input = searchBar.querySelector('.mobile-search-bar__input');
        if (input) input.focus();
      }, 350);
    }

    function closeSearch() {
      searchBar.classList.remove('is-open');
    }

    document.querySelectorAll('[data-mobile-search-open]').forEach(function(btn) {
      btn.addEventListener('click', openSearch);
    });

    var closeBtn = searchBar.querySelector('[data-mobile-search-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  }

  /* [MOBILE-MENU] */
  function initMobileMenu() {
    var menuDrawer = document.querySelector('[data-mobile-menu-drawer]');
    var menuOverlay = document.querySelector('[data-mobile-menu-overlay]');
    if (!menuDrawer || !menuOverlay) return;

    function openMenu() {
      menuDrawer.classList.add('is-open');
      menuOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      menuDrawer.classList.remove('is-open');
      menuOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    /* Hamburger i mobil header */
    var hamburger = document.querySelector('.header-mobile__hamburger');
    if (hamburger) hamburger.addEventListener('click', openMenu);

    /* Kategorier-knap i bottom nav */
    document.querySelectorAll('[data-mobile-menu-open]').forEach(function(btn) {
      btn.addEventListener('click', openMenu);
    });

    /* Luk-knap og overlay */
    menuDrawer.querySelectorAll('[data-mobile-menu-close]').forEach(function(btn) {
      btn.addEventListener('click', closeMenu);
    });
    menuOverlay.addEventListener('click', closeMenu);
  }

  initScrollShowcase();
  initVariantSystem();
  initConfigurator();
  initLkTangentSelector();
  repositionLkSlots();
  initAccordions();
  initMobileSearch();
  initMobileMenu();

}); // end DOMContentLoaded
